import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["confirmation"]
  static values = { text: String }

  // Called from an <a target="_blank"> click — do NOT preventDefault so the
  // link navigates naturally. <a target="_blank"> opens the new tab in the
  // background and keeps focus on this document, so the clipboard write
  // succeeds. window.open() immediately steals focus and would cause the
  // async writeText to fail.
  copy() {
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(this.textValue)
        .then(() => this.showConfirmation())
        .catch(() => {})
    }
  }

  showConfirmation() {
    if (!this.hasConfirmationTarget) return
    this.confirmationTarget.classList.remove("hidden")
    clearTimeout(this.hideTimeout)
    this.hideTimeout = setTimeout(() => {
      this.confirmationTarget.classList.add("hidden")
    }, 2400)
  }
}
